import React from 'react';
import { Phone } from 'lucide-react';
import { translations } from '../utils/translations';
interface EmergencyHeaderProps {
  lang: string;
}
export function EmergencyHeader({
  lang
}: EmergencyHeaderProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  return <header className="relative w-full bg-brand-black min-h-[80vh] flex flex-col items-center justify-center px-4 py-20 overflow-hidden" data-id="element-20">
      {/* Background Overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-brand-black z-0" data-id="element-21"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center w-full max-w-4xl mx-auto" data-id="element-22">
        <div className="mb-8 w-48 h-48 md:w-56 md:h-56 flex items-center justify-center" data-id="element-23">
          <img src="https://cdn.magicpatterns.com/uploads/gbD8hKufJEC7SSgGgGcMCM/IMG_8096.jpg" alt="OJ Auto Group LLC Logo" className="max-w-full max-h-full object-contain" data-id="element-24" />
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl text-white mb-6 leading-tight text-shadow-md" data-id="element-25">
          {t.heroTitle} <br className="hidden md:block" data-id="element-26" />
          <span className="text-brand-red" data-id="element-27">{t.heroTitleHighlight}</span>{' '}
          {t.heroTitleSuffix}
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 font-medium mb-10 max-w-2xl" data-id="element-28">
          {t.heroSubtitle}
        </p>

        <a href="tel:+17862232564" className="flex items-center justify-center w-full md:w-auto px-8 h-16 bg-brand-red hover:bg-brand-darkred text-white text-xl font-heading tracking-wider rounded-md transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(255,0,0,0.4)]" data-id="element-29">
          <Phone className="w-6 h-6 mr-3 fill-current" data-id="element-30" />
          {t.heroCTA}
        </a>
      </div>
    </header>;
}